import React from "react";
import LegalLayout, { H2, P, UL } from "./LegalLayout";
import SEO from "../components/SEO";

const UPDATED = "3 noiembrie 2026";

/** The Black Friday 2026 campaign rules (EMAG voucher), linked from the footer. */
export default function BlackFridayRules() {
  return (
    <>
      <SEO
        title="Regulamentul campaniei Black Friday | FPED"
        description="Regulamentul campaniei Black Friday 2026 la cursul «Introducere în Inteligența Artificială pentru educație»: voucher EMAG de 150 lei pentru înscrierile din perioada 02.11–15.11.2026."
        canonical="https://ai.fped.org/regulament-black-friday"
      />
      <LegalLayout
        title="Regulamentul campaniei Black Friday"
        lastUpdated={UPDATED}
        testid="black-friday-rules-page"
      >
      <H2>1. Organizatorul campaniei</H2>
      <P>
        Campania este organizată de <strong>Fundația pentru Educație Digitală (FPED)</strong>, cu sediul în
        București, Sectorul 1, Str. Ioan Bianu Nr. 27, CIF 43506207.
      </P>

      <H2>2. Perioada campaniei</H2>
      <P>
        Campania Black Friday se desfășoară în perioada <strong>02.11.2026 – 15.11.2026</strong>, în limita
        locurilor disponibile.
      </P>

      <H2>3. Beneficiul oferit</H2>
      <P>
        În cadrul campaniei, participanții care se înscriu la cursul „Introducere în Inteligența Artificială
        pentru educație” beneficiază de un <strong>voucher EMAG în valoare de 150 lei</strong>.
      </P>

      <H2>4. Condiții de participare</H2>
      <P>
        Oferta este valabilă pentru înscrierile în grupele cu începere în lunile noiembrie 2026 și ianuarie 2027.
      </P>
      <P>Pentru a beneficia de voucher, participanții trebuie:</P>
      <UL>
        <li>să completeze formularul de înscriere în perioada campaniei;</li>
        <li>să selecteze una dintre grupele eligibile;</li>
        <li>să finalizeze procesul de înscriere și plată a cursului, conform procedurii de înregistrare.</li>
      </UL>

      <H2>5. Acordarea voucherului</H2>
      <P>
        Voucherul în valoare de 150 lei va fi acordat electronic, la adresa de e-mail, în termen de 20 de zile de
        la data înscrierii, plății și confirmării în grupă.
      </P>

      <H2>6. Alte prevederi</H2>
      <UL>
        <li>
          Oferta nu se cumulează cu alte promoții, cu excepția cazului în care organizatorul comunică explicit
          acest lucru.
        </li>
        <li>Voucherul nu poate fi preschimbat în bani.</li>
        <li>
          Organizatorul își rezervă dreptul de a modifica regulamentul, cu informarea prealabilă a
          participanților, în condițiile legii.
        </li>
      </UL>
      <P>
        Prin participarea la campanie, participanții declară că au citit și acceptă prezentul regulament.
      </P>
      <P>
        Pentru informații suplimentare:{" "}
        <a href="https://ai.fped.org" className="text-[#965EA7] underline">ai.fped.org</a>.
      </P>
      </LegalLayout>
    </>
  );
}
